import styled from 'styled-components';

import H2 from 'components/H2';

export default styled(H2)`
  margin-top: 5vw;

  &:first-child {
    margin-top: 0;
  }
`;
